export default "__VITE_ASSET__6lu$y5yV__"